import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Select } from './Select';

/**
 * AccountFilter Component
 *
 * Reusable account filter select for SuperAdmin views.
 * Only renders if the user is a SuperAdmin.
 *
 * @param {Object} props
 * @param {boolean} props.isSuperAdmin - Whether the current user is a SuperAdmin
 * @param {Array} props.accounts - Array of account objects with id and name
 * @param {string} props.value - Currently selected account ID
 * @param {Function} props.onChange - Change handler for select
 * @param {string} props.className - Additional CSS classes for the wrapper
 */
export function AccountFilter({ isSuperAdmin, accounts = [], value, onChange, className = '' }) {
  const { t } = useTranslation();

  if (!isSuperAdmin) {
    return null;
  }

  return (
    <Select
      label={t('common.filterByAccount', 'Filter by Account')}
      value={value}
      onChange={onChange}
      className={className}
    >
      <option value="">{t('superadmin.allAccounts', 'All Accounts')}</option>
      {accounts.map((account) => (
        <option key={account.id} value={account.id}>
          {account.name}
        </option>
      ))}
    </Select>
  );
}

AccountFilter.propTypes = {
  isSuperAdmin: PropTypes.bool.isRequired,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
